import { getURLParam } from "./Utilities";

export const getPageSize = () => {
    return +getURLParam("size") || 20;
}

export const getCurrentPage = () => {
    return +getURLParam("page") || 1;
}